module.exports = __webpack_public_path__ + "img/country-insights-nigeria.814b03c1.jpg";